import { useMutation as useMutationLib } from 'react-query'

const useQuery = useMutationLib

export default useQuery
